import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import './css/index.css';
import AppContainer from './containers/app';
import rootReducers from './reducers';
import preloadedState from './state';
import persiste from './middlewares/persiste';

import 'typeface-roboto';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let middlewares = [thunk/*, persiste*/];

if (process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
}

var state = false;//window.sessionStorage["__state_financiamentointerno_v1"];
if (state) {
    state = JSON.parse(state);
    if (state.valueAbaIndex === 1 && !window.__token_tokenFiador__ ||
        state.valueAbaIndex === 0 && window.__token_tokenFiador__) {
        window.sessionStorage.clear();
        state = preloadedState;
    }
} else {
    state = preloadedState;
}

const store = createStore(rootReducers, state,
    composeEnhancers(
        applyMiddleware(...middlewares)
    )
);




ReactDOM.render(
    <Provider store={store}>
        <AppContainer />
    </Provider>, document.getElementById('root-financiamento-interno'));


// WEBPACK FOOTER //
// ./src/index.js